module.exports = __webpack_public_path__ + "img/img_新闻03.146142a9.png";